import React, { Component } from 'react';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom'
import { Form, Button, Search, Icon, Input } from 'semantic-ui-react';
import styles from './navbar.scss';
import Signin from '../user/signin';
import UserDropdown from '../user/UserDropdown';
import history from "../../history"


class Navbar extends Component {
  constructor() {
    super();
    this.state = {
      location: '',
      redirect: false
    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.inputHandler = this.inputHandler.bind(this);
  }

  handleKeyPress (event) {
    if (event.key == "Enter") {
      let url = '/house?location=' + this.state.location;
      history.push(url);
    }
  }

  inputHandler(event) {
    var val = event.target.value;
    this.setState({
      location: val
    });
  }

  render() {
    //localStorage.clear();
    const IsLogin = localStorage.hasOwnProperty('user');
    return (
          <div className='navbar'>
          <div className='search_bar'>
            <Icon className="search_icon" name="search"/>
            <Input placeholder="Search the city..." value={this.state.location} onChange={this.inputHandler} onKeyPress={this.handleKeyPress}/>
          </div>
            <div className='button-group'>
              {IsLogin?
                  <UserDropdown user={localStorage.getItem('user')} token={localStorage.getItem('token')}/>:
                  <Signin/>
              }
            </div>
        </div>

    );
  }
}


export default Navbar;
